<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap mb-3 align-items-center">
            <h1 class="my-0 mr-2">Fotos</h1>
            <div class="form-control uhe-search-input-wrapper d-flex">
                <i class="material-icons mr-1">search</i>

                <input
                    ref="searchInput"
                    class="uhe-search-input flex-fill"
                    type="search"
                    placeholder="Suche"
                    aria-label="Suche"
                    @input="onSearchInput"
                />
            </div>
        </div>
        <div v-if="!imageCollections.length">Keine Sammlungen vorhanden</div>
        <div v-else>
            <div class="d-flex">
                <div class="col px-0 w-50" v-for="n in numColumns" :key="n">
                    <div
                        v-for="imageCollection in columns[n - 1]"
                        :key="imageCollection.id"
                        class="uhe-imgcol-wrapper my-3 mx-lg-2 uhe-cursor-pointer"
                        @click="onOverlayClick(imageCollection.id)"
                    >
                        <div class="uhe-imgcol-innerwrapper">
                            <div
                                class="d-flex flex-column justify-content-between uhe-imgcol-overlay"
                            >
                                <div class="flex-grow-1 uhe-overlay-fade"></div>
                                <div
                                    class="uhe-imgcol-overlay-titlebar p-2 d-flex justify-content-between flex-wrap text-white"
                                >
                                    <div class="d-flex align-items-center flex-wrap">
                                        <h4 class="mb-0 mr-2">{{ imageCollection.title }}</h4>
                                        <span
                                            v-if="imageCollection.image_tag != null"
                                            class="mr-1"
                                            :class="[
                                            'badge',
                                            'badge-' +
                                                imageCollection.image_tag.color
                                        ]"
                                        >
                                            {{
                                            imageCollection.image_tag.title
                                            }}
                                        </span>
                                        <small
                                            v-if="
                                            imageCollection.created_at !=
                                                undefined
                                        "
                                            class="text-white"
                                        >
                                            {{
                                            imageCollection.locale_created_at
                                            }}
                                        </small>
                                    </div>
                                    <a
                                        :href="'/fotos/' + imageCollection.id"
                                        class="uhe-link text-white uhe-d-pointer my-auto d-none d-lg-block"
                                    >→ Zur Sammlung</a>
                                </div>
                            </div>
                            <div class="uhe-imgcol-content uhe-scale p-1 d-flex">
                                <div class="uhe-col px-1">
                                    <img
                                        v-if="imageCollection.preview_images[0]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[0]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[0]
                                            .thumbPath
                                    "
                                    />
                                    <img
                                        v-if="imageCollection.preview_images[3]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[3]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[3]
                                            .thumbPath
                                    "
                                    />
                                </div>
                                <div class="uhe-col px-1">
                                    <img
                                        v-if="imageCollection.preview_images[1]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[1]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[1]
                                            .thumbPath
                                    "
                                    />
                                    <img
                                        v-if="imageCollection.preview_images[4]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[4]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[4]
                                            .thumbPath
                                    "
                                    />
                                </div>
                                <div class="uhe-col px-1">
                                    <img
                                        v-if="imageCollection.preview_images[2]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[2]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[2]
                                            .thumbPath
                                    "
                                    />
                                    <img
                                        v-if="imageCollection.preview_images[5]"
                                        class="uhe-imgcol-img py-1"
                                        :src="
                                        '/storage/' +
                                            imageCollection.preview_images[5]
                                                .thumbPath
                                    "
                                        :alt="
                                        imageCollection.preview_images[5]
                                            .thumbPath
                                    "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <paginator :data="paginatorInfo" @changePage="getImageCollections"></paginator>
        </div>
    </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
    components: {
        VueCropper
    },
    data() {
        return {
            paginatorInfo: undefined,
            imageCollections: [],
            columns: [],
            numColumns: 2
        };
    },
    mounted() {
        this.getImageCollections();
        window.addEventListener("resize", this.onResize);
        this.onResize();
    },
    methods: {
        getImageCollections(page = -1, q = "") {
            let url = "/imageCollectionsPublicWithPreviewImages";
            let searchUrl = "/search/imageCollections";

            if (q == "" && this.q != undefined) q = this.q;

            if (page < 0) {
                if (q != "") {
                    url = searchUrl + "?q=" + q;
                }
            } else {
                if (q == "") {
                    url += "?page=" + page;
                } else {
                    url = searchUrl + "?page=" + page + "&q=" + q;
                }
            }
            window.axios.get(url).then(({ data }) => {
                this.paginatorInfo = data;
                this.imageCollections = data.data;
                this.calcColumns();
            });
        },
        calcColumns() {
            if (this.screenWidth == "xs" || this.screenWidth == "sm") {
                this.columns[0] = this.imageCollections;
                this.numColumns = 1;
            } else {
                this.numColumns = 2;
                this.columns = [];
                this.columns[0] = [];
                this.columns[1] = [];
                this.imageCollections.forEach((coll, ind) => {
                    if (ind % 2) {
                        this.columns[1].push(coll);
                    } else {
                        this.columns[0].push(coll);
                    }
                });
            }
        },
        onSearchInput(e) {
            if (this.timeout == undefined) {
                this.timeout = setTimeout(this.search, 250);
            } else {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(this.search, 250);
            }
        },
        search(page = -1) {
            if (this.$refs.searchInput.value == "") {
                this.getImageCollections(page);
            } else {
                this.getImageCollections(page, this.$refs.searchInput.value);
            }
        },
        onOverlayClick(id) {
            window.location = "/fotos/" + id;
        },
        onResize() {
            let width = undefined;
            if (screen.width < 576) width = "xs";
            else if (screen.width < 768) width = "sm";
            else if (screen.width < 992) width = "md";
            else if (screen.width < 1200) width = "lg";
            else width = "xlg";

            this.screenWidth = width;
            this.calcColumns();
        }
    }
};
</script>

<style scoped>
.uhe-imgcol-wrapper {
    max-width: 100%;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2),
        0 12px 30px 0 rgba(0, 0, 0, 0.19);
}

.uhe-imgcol-wrapper:hover .uhe-scale {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -o-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
}

.uhe-imgcol-innerwrapper {
    min-height: 2.75rem;
    max-height: 250px;
    position: relative;
    overflow: hidden;
}

.uhe-imgcol-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
}

.uhe-imgcol-img {
    width: 100%;
}

.uhe-imgcol-content {
    width: 100%;
    background-color: white;
}

.uhe-col {
    width: 33.33%;
}
</style>


